/**
 * 用户使用帮助配置
 */

import { RouterLink } from 'vue-router';
const useHelpList = [
	{
		title: '多动屏能用来做什么？',
		list: [
			'1. 多动屏是一套互联网软件系统。可以让一台普通的智能电视/盒子/广告机变为一台多用途的广告屏/播放器。',
			'2. 多动屏尤其适用于有大量客流的实体商家和服务性营业点。帮助他们轻松发送实时信息和广告等。',
			'3. 使用者无需复杂的设置，仅通过微信就可以对设备进行控制和发布，且没有距离限制。',
			'4. 根据设置不同，设备可以变身为一台广告屏/走字屏/mp3播放器/网络电视机/电影播放器等。',
		],
	},
	{
		title: '如何连接(绑定)我的手机和设备？',
		list: [
			'1. 手机端：需要在个人微信上公众号“多动屏”中注册一个帐号。',
			'2. 设备端：安装完APP后第一次启动的时候，会出现“激活”页面。',
			'3. 根据提示扫描二维码完成激活，即可将设备绑定到您的帐号下。',
			'* 一个帐号可以绑定若干台设备。',
			'* 一台设备只需要也只能被激活一次。',
		],
	},
	{
		title: '为何我的设备上没有出现“激活”页面？',
		list: [
			'1. 请检查网络连接，确保网络畅通。',
			'2. 请退出APP，再次启动。',
			'3. 如果设备之前已被他人激活过，那么之后将不再需要激活。',
			'4. 如果遇到无法激活，请联系运营人员(QQ群：220953623)。',
		],
	},
	{
		title: '当有多台多动屏时，该如何分别控制？',
		list: [
			'1. “首页”中，点击页面顶端的设备名。',
			'2. “切换当前设备”中选择要控制的设备。',
			'3. 当名下拥有的设备较多时，建议在电脑上登录客户端 https://www.duodongping.com/ 进行控制和编排。',
			'* 请为每台设备设定不同的名字和头像，以方便区分。',
		],
	},
	// 
	{
		title: '如何发布媒体文件到设备上循环播放？',
		list: [
			'1. 在“媒体·播放”中点选浮动的“上传”按键。',
			'2. 上传后可自动推送到设备上循环播放。',
			'3. 如果媒体不再需要播放，可向左滑动该媒体，临时“撤下”或永久“删除”。',
		],
	},
	{
		title: '如何让字幕或音乐在设备上循环播放？',
		list: [
			'1. 在“媒体·播放”中选择字幕或音乐列表。',
			'2. 点击右上角的配置按钮，弹出配置窗口。',
			'3. 开启（或关闭）连播开关。',
		],
	},
	{
		title: '为什么我的设备上不显示滚动字幕？',
		list: [
			'1. 部分电视机不支持浮动功能。',
			'2. 您可以在电视机系统设置中，找到“权限管理”中“悬浮窗”，并授予“多动屏”此权限。',
			'3. 或者等待设备端软件到更新的版本(暂未发布)。',
			'4. 或者在我们的QQ技术群中向运营人员咨询。',
		],
	},
	{
		title: '如何更便捷的上传媒体文件？',
		list: [
			'1. 在电脑的浏览器上登录 https://www.duodongping.com/。',
			'2. 在“我的媒体”中批量上传您的媒体文件。',
			'3. 在“我的媒体”中，逐个修改这些媒体文件的标题和播放时长等。',
			'4. 在“简易控制”中，选择并添加您的媒体文件到指定设备。',
		],
	},
	{
		title: '上传媒体后，如何查看设备是否成功接收并可以播放该媒体？',
		list: [
			'1. 在“首页”中，点击“实时遥控”，点击中央的“设备状态”，则显示当前设备存储和任务信息。',
			'2. 当“未执行任务数”为0时，表明所有任务已被正常接收，并进入到循环播放队列中。',
			'3. 此时，点击任意媒体的“播放”按钮，即可直接点播。',
		],
	},
	{
		title: '如何不改变原有的播放列表，而临时独播单个媒体？',
		list: [
			'1. 先上传要独播的媒体文件到列表，确认该媒体可以正常点播。',
			'2. 之后，在播放列表中，逐个向左滑动的剩余媒体，“撤下”这些媒体，仅保留要独播的媒体。',
			'3. 当需要独播的任务结束后，再反向操作，逐个“展播”之前被“撤下”的媒体。',
		],
	},
	{
		title: '如果没有稳定网络时，该如何让多动屏软件正常工作呢？',
		list: [
			'1. 当没有固定网络时，可以用自己的手机热点作为临时网络，将设备连入。',
			'2. 安装多动屏并成功激活和绑定，导入需要发布的媒体内容。',
			'3. 确保每个媒体文件都能正常"点播"。或者在“首页”的“实时遥控”的“设备状态”中确认“未执行任务数”为0。',
			'4. 此时所有任务都已经完成，可以断开手机热点。多动屏将播放缓存到本地的媒体文件。',
		],
	},
	// {
	// 	title: '我是否可以在电脑上操作微信客户端？',
	// 	list: [
	// 		'1.可以。同手机一样，只需在您的电脑上打开微信并进入“多动屏”公众号，其他操作是一样的。',
	// 		'2.注意：手机屏幕上独有的操作，比如“滑动”等，可能在电脑上不被支持。',
	// 	],
	// },
	{
		title: '什么是“分屏模式”？',
		list: [
			'1. “分屏模式”下，多动屏的屏幕会被分割成若干个区域，以显示不同的内容。',
			'2. 如果需要制作复杂的分屏，请先在电脑客户端中制作，然后发布到设备上。',
		],
	},
	{
		title: '如何调整播放列表中的播放顺序？',
		list: [
			'1. 列表中，单击单个节目(媒体)，在“编辑”中修改播放顺序。'
		],
	},
	{
		title: '我有多台设备，如何批量发布内容？',
		list: [
			'1. 请登录电脑客户端：https://www.duodongping.com/。',
			'2. 在电脑客户端，批量上传您的媒体文件。',
			'3. 在“简易发布”中，快速操作多台设备，批量导入媒体到多台设备或独立编排单台设备。',
		],
	},
	// {
	// 	title: '什么是“多屏同步”功能？',
	// 	list: [
	// 		'1. “多屏同步”是指，当有多台设备播放相同内容时，通过软件设定，可以让多台设备的画面同步显示。',
	// 		'2. 注意：需要同步的所有设备需配置相同的播放列表。既，播放内容和顺序需要完全一致，且单个媒体的默认播放时长必须一致。',
	// 		'3. 请登录电脑客户端，更多了解“多屏同步”。',
	// 	],
	// },
	// {
	// 	title: '什么是“触摸功能”？',
	// 	list: [
	// 		'1. 部分商业显示屏允许触摸操作。（普通电视机、盒子、投影仪等硬件本身不支持触摸操作！）',
	// 		'2. 当设备的硬件支持触摸操作时，开启软件“触摸功能”后，允许用户手指在屏幕上，切换节目等操作。',
	// 		'3. 注意，请先确认硬件是否支持触摸操作！',
	// 	],
	// },
	{
		title: '什么是“抽奖游戏”？如何制作和使用？',
		list: [
			'1. “抽奖游戏”的目的是帮助商家在店铺现场就能举行一场简单的促销活动，达到吸引客流和增加销量的目的。',
			'2. 制作完成的抽奖游戏可以在发布到屏幕上展现，任何一位顾客都可以使用微信在广告屏上直接参与游戏抽奖。',
			'3. 制作者应合理设定奖品和中奖概率，从而尽可能的吸引顾客。同时，商家应对抽奖结果负责。',
		],
	},

	// {
	// 	title: '什么是“红包雨游戏”？如何制作和使用？',
	// 	list: [
	// 		'1. “红包雨游戏”的目的是帮助商家在现场就能举行一场简单的促销活动。与“抽奖游戏”不同的是，它允许多人同时互动、',
	// 		'2. 商家在手机上就能轻松制作和发布一个红包雨游戏。',
	// 		'3. 发布到设备的屏幕上显示后，任何一个消费者都可以使用手机扫码，触发游戏，并领取奖品。从而达到吸引顾客进店消费的目的。',
	// 	],
	// },
	{
		title: '什么是“手绘小黑板”？如何使用？',
		list: [
			'1. “手绘小黑板”是为了取代传统的粉笔黑板和LED荧光板。',
			'2. 商家可以方便的在手机上书写和绘制店铺信息，实时推送到设备屏幕上展示。',
			'3. 为了让展示内容更有个性，还可以选择不同的显示特效，以增强吸引力。',
		],
	},
	{
		title: '如何知道多动屏的当前在线和工作状态？',
		list: [
			'1. “首页”的顶部设备名旁边，绿灯亮表示设备在线，红灯亮表示离线。',
			'2. 点击“首页”中“实时操控”中的设备设备状态图标，可查看当前设备的运行状况。',
			'3. 在设备的“参数与设置”中，也可以通过远程截屏，实时查看当前屏幕的显示画面。',
		],
	},
	{
		title: '设备或客户端提示“空间不足”时，该如何处理？',
		list: [
			'1. “空间不足”：表示设备上的存储空间已满，或即将存满，无法处理剩下的播放任务。可以采用以下方法：',
			'2. A: 删除播放列表中不用的媒体，以释放空间。',
			'3. B: 插入新的容量足够大的TF卡SD卡U盘等作为外接存储设备。（部分设备可能需要重启软件。）',
			'4. 客户端可以实时查看存储空间剩余情况。',
		],
	},
	{
		title: '如何授予其他人我的设备的管理员帐号？',
		list: [
			'1. “首页”中，点击右上角的设置图标。',
			'2. “参数与配置”中，点击“设备管理员”。',
			'3. 输入新管理员注册过的手机号码，完成添加。',
			'4. 注意：只有超级管理员才有此权限。为了安全考虑，请勿添加过多的设备管理员。',
		],
	},
	{
		title: '什么是“免密登录”？',
		list: [
			'1. “免密码登录”是为了方便初次试用本软件用户。可无需注册账号，临时登录试用。',
			'2. 试用后，如果需要长期使用本软件，用户必须要手机号注册。',
			'3. “免密码登录”作为临时账号会有诸多限制，建议尽快注册账号。',
		],
	},
	// {
	// 	title: '如何快速进入“多动屏”的微信客户端？',
	// 	list: [
	// 		'1. 在“多动屏”的公众号页面，点击右上角菜单，选择“添加到桌面”可以在手机上创建快捷方式。',
	// 		'2. 在客户端登陆页面，选中“记住密码”则可以免去每次输入密码的操作。',
	// 	],
	// },
	{
		title: '我在电脑上制作的PPT格式的内容，如何发布？',
		list: [
			'1. 在Microsoft PowerPoint中，选中菜单中的“文件”->“保存并发送”->“更改文件类型”，保存成图片或视频。',
			'2. 之后上传并发布到多动屏。',
			'3. 其他格式的文件也可采用类似方法。',
		],
	},
	{
		title: '如何解除我账号下的某台设备的绑定？',
		list: [
			'1. 请前往QQ技术群向运营人员咨询。（QQ群：220953623）',
			'2. 或者，在“设置”中“软件授权”的“重置与解绑”页面中，对当前设备进行重置操作。',
		],
	},
	{
		title: '没有找到我需要的功能怎么办？',
		list: [
			'1. 更多功能，请登录电脑客户端：https://www.duodongping.com/。',
			'2. 或者，在“我的”中“意见反馈”中提交您的想法和需求，对于合理的公共需求，我们将会在以后的版本中增加。',
		],
	},
	{
		title: '我是否需要为软件和服务付费？',
		list: [
			'1. 多动屏被激活后，您可以免费试用一个月。',
			'2. 试用后，您需要在线支付一定的服务费，以获得稳定和更全面的服务。',
			<>
				3. 请在设备的“设置与参数”页面底部的
				<RouterLink class="link" to="/devfee">
					“软件授权”
				</RouterLink>
				中使用微信支付。
			</>,
			'4. 如需发票，请在成功支付后，在“账单发票”中“索取发票”。',
			'5. 服务期内，因硬件损坏需要更换设备的，可免费迁移剩余服务期到新的设备。',
			'6. 如有问题，请在QQ群中向运营人员咨询。',
		],
	},
];

export default useHelpList;
